import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import type { FilesystemActivityResponse } from '../models/api';

@Injectable({ providedIn: 'root' })
export class FilesystemActivityService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(ATTACHMENTS_HANDLER_CONFIG).apiUrl;

    getFilesystemActivity(page = 1): Observable<FilesystemActivityResponse> {
        return this.http.get<FilesystemActivityResponse>(
            `${this.baseUrl}filesystem-activities/filesystem`,
            { params: new HttpParams().set('page', page) },
        );
    }

    getLinkActivity(page = 1): Observable<FilesystemActivityResponse> {
        return this.http.get<FilesystemActivityResponse>(
            `${this.baseUrl}filesystem-activities/links`,
            { params: new HttpParams().set('page', page) },
        );
    }
}
